import { useRecoilState } from 'recoil';
import { inputboxCancelActionState, inputboxCancelTextState, inputboxConfirmActionState, inputboxConfirmTextState, inputboxInputState, inputboxMessageState } from '../../atoms/common';
import "./Inputbox.scoped.scss"
import { getRecoil, setRecoil } from "recoil-nexus";

function Inputbox() {
  const inputboxConfirmAction = getRecoil(inputboxConfirmActionState);
  const inputboxCancelAction = getRecoil(inputboxCancelActionState);
  const inputboxConfirmText = getRecoil(inputboxConfirmTextState);
  const inputboxCancelText = getRecoil(inputboxCancelTextState);
  const inputboxMessage = getRecoil(inputboxMessageState);
  const [, setInputboxInput] = useRecoilState(inputboxInputState);

  return (
    <div className="confirm-warpper">
      <div className="confirm">
        <div className="confirm__header">
          <div>확인</div>
        </div>
        <div className="confirm__contents">
          <div className="confirm__row" dangerouslySetInnerHTML={{ __html: inputboxMessage.split('\n').join('<br/>')}}>
          </div>
          <div className="confirm__input">
            <input type="text" onChange={(e) => {
              setInputboxInput(e.target.value);
            }} />
          </div>
          <div className="confirm__button">
            <button onClick={inputboxCancelAction}>{inputboxCancelText}</button>
            <button className="confirm-button" onClick={inputboxConfirmAction}>{inputboxConfirmText}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inputbox;